import {Injectable} from '@angular/core';
import {Action, Selector, State, StateContext} from '@ngxs/store';
import {firstValueFrom} from 'rxjs';
import {environment} from '../../../environments/environment';
import {BaseService, DataBaseServiceResponse} from '../../services/base-service/base.service';
import {IRefFoodTags} from './ref-food-tags.interface';

export interface IRRefFoodTags {
  refFoodTags: IRefFoodTags[];
}


export namespace RefFoodTagsAction {
  export class Get {
    static readonly type = '[Ref Food Tags] Get Ref Food Tags Action';
    constructor() {}
  }

}

@State<IRRefFoodTags>({
  name: 'RefFoodTagsState',
  defaults: {
    refFoodTags: []
  }
})

@Injectable()
export class RefFoodTagsState {
  constructor(
    private baseService: BaseService<any>
  ) {}

  url = environment.SERVER_URL;

  @Selector()
  public static getRegFoodTags(state: IRRefFoodTags): IRefFoodTags[] {
    return state.refFoodTags;
  }

  @Action(RefFoodTagsAction.Get)
  async getRefFoodTagsAction(ctx: StateContext<IRRefFoodTags>, _: RefFoodTagsAction.Get): Promise<void> {
    const response: DataBaseServiceResponse<IRefFoodTags[]> = await firstValueFrom(
      this.baseService.get(`${this.url}/ref-food-tags`, void 0)
    );

    if (response.error) throw new Error(response.message);

    ctx.patchState({refFoodTags: response.entity});
  }

}
